var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 3.82597C22.0424 4.50145 20.9821 5.01808 19.86 5.35597C19.2577 4.66348 18.4573 4.17267 17.567 3.9499C16.6767 3.72713 15.7395 3.78317 14.8821 4.11043C14.0247 4.43768 13.2884 5.02038 12.773 5.77969C12.2575 6.53901 11.9877 7.43831 12 8.35597V9.35597C10.2426 9.40154 8.50127 9.01179 6.93101 8.22142C5.36074 7.43105 4.01032 6.26461 3 4.82597C3 4.82597 -1 13.826 8 17.826C5.94053 19.2239 3.48716 19.9249 1 19.826C10 24.826 21 19.826 21 8.32597C20.9991 8.04743 20.9723 7.76957 20.92 7.49597C21.9406 6.48947 22.6608 5.21869 23 3.82597V3.82597Z",
    stroke: "#011563",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.a3100361d22ddeee2733f501d07f96db.svg";
export { ForwardRef as ReactComponent };